import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'
import { type VariantProps, cva } from 'class-variance-authority'

const expansionArrowsIconVariants = cva('', {
  variants: {
    expanded: {
      true: '',
      false: cn(
        '[&_[data-expansion-top]]:-translate-y-[125%] [&_[data-expansion-top]]:translate-x-[125%]',
        '[&_[data-expansion-bottom]]:-translate-x-[125%] [&_[data-expansion-bottom]]:translate-y-[125%]'
      ),
    },
  },
})

export function ExpansionArrowsIcon({
  className,
  size = 20,
  expanded,
  ...props
}: IconProps & VariantProps<typeof expansionArrowsIconVariants>) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size }), expansionArrowsIconVariants({ expanded }), className)}
      {...props}
    >
      <g className="origin-center transition-transform [transform-box:fill-box]" data-expansion-top>
        <path
          d="M10.7427 12.5075L6.50009 12.5075C6.08588 12.5075 5.75009 12.8433 5.75009 13.2575C5.75009 13.6717 6.08588 14.0075 6.50009 14.0075L8.93207 14.0075L4.46991 18.4697C4.17702 18.7626 4.17702 19.2374 4.46991 19.5303C4.76281 19.8232 5.23768 19.8232 5.53057 19.5303L9.99274 15.0682L9.99274 17.5002C9.99274 17.9144 10.3285 18.2502 10.7427 18.2502C11.157 18.2502 11.4927 17.9144 11.4927 17.5002L11.4927 13.2575C11.4927 13.0586 11.4137 12.8678 11.2731 12.7272C11.1324 12.5865 10.9416 12.5075 10.7427 12.5075Z"
          fill="currentColor"
        />
      </g>
      <g className="origin-center transition-transform [transform-box:fill-box]" data-expansion-bottom>
        <path
          d="M19.5303 5.52996C19.8232 5.23707 19.8232 4.7622 19.5303 4.4693C19.2374 4.17641 18.7625 4.17641 18.4696 4.4693L14.0074 8.93152L14.0074 6.4995C14.0074 6.08529 13.6716 5.7495 13.2574 5.7495C12.8432 5.7495 12.5074 6.08529 12.5074 6.4995L12.5074 10.7422C12.5074 10.9411 12.5864 11.1319 12.7271 11.2725C12.8677 11.4132 13.0585 11.4922 13.2574 11.4922L17.5 11.4921C17.9143 11.4921 18.25 11.1563 18.25 10.7421C18.25 10.3279 17.9142 9.99214 17.5 9.99214L15.0681 9.99216L19.5303 5.52996Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
